import clsx from 'clsx';
import React from 'react';
import { ComboBoxItem } from './ComboBoxItem';
export function ComboBoxAddItem(props) {
    const { className, ...rest } = props;
    return (React.createElement(ComboBoxItem, { ...rest, className: clsx('mollie-ui-combo-box-add-item', className) }));
}
ComboBoxAddItem.displayName = 'ComboBox.AddItem';
//# sourceMappingURL=ComboBoxAddItem.js.map